"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStream = void 0;
const react_1 = require("react");
function useStream(createStream$, props, initialValue) {
    const subscriptionRef = react_1.useRef(undefined);
    const setValueRef = react_1.useRef(undefined);
    const first = react_1.useMemo(() => {
        if (subscriptionRef.current !== undefined) {
            subscriptionRef.current.unsubscribe();
        }
        let firstValue = initialValue;
        subscriptionRef.current = createStream$().subscribe({
            next: (nextValue) => {
                firstValue = nextValue;
                if (setValueRef.current !== undefined) {
                    setValueRef.current(nextValue);
                }
            },
        });
        return firstValue;
    }, [...props, subscriptionRef, setValueRef]);
    react_1.useEffect(() => () => {
        if (subscriptionRef.current !== undefined) {
            subscriptionRef.current.unsubscribe();
        }
    }, [subscriptionRef]);
    const [value, setValue] = react_1.useState(first);
    setValueRef.current = setValue;
    return value;
}
exports.useStream = useStream;

//# sourceMappingURL=useStream.js.map
